import React, { useLayoutEffect } from "react";

import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import BottomBanner from "../components/bottombanner/bottombanner";
import ContactUs from "../components/contactus/contactus";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";

function ContactMKE() {
  useLayoutEffect(() => {
   document.title = 'Contact Us - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
  }, []);

  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Connect" pic="/images/sai-mke-Contacts.png"/>
        <ContactUs />
        <Menucardforallpage page="contact" />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default ContactMKE;
